import { defineMessages } from '@transcend-io/internationalization';

export const heroPageMessages = defineMessages(
  'privacy-center.routes.HeroPage.heroPage',
  {
    organizationLogoAlt: {
      defaultMessage: '{organizationName} logo',
    },
    transcendLogoAlt: {
      defaultMessage: 'Transcend logo',
    },
    navLabel: {
      defaultMessage: 'Main Menu',
    },
    skipToNavigation: {
      defaultMessage: 'Skip to navigation',
    },
    skipToSidebar: {
      defaultMessage: 'Skip to sidebar',
    },
    skipToMain: {
      defaultMessage: 'Skip to main content',
    },
  },
);
